import { useAvatarStore } from "components/InteractiveAvatar/avatarStore";
import { useRouter } from "next/router";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

type Props = {
  icon?: string;
  size?: number;
};

export const IconGaiaMenu: React.FC<Props> = ({
  icon = "/images/gaia-menu-inactive.png",
  size = 40,
}) => {
  const router = useRouter();
  const { isLoadingSessionNxtx } = useAvatarStore();

  const variants = {
    squeezeBoth: {
      scale: [1, 0.8, 1.1, 0.8, 1],
      borderRadius: [
        `${size * 0.2}px`,
        `${size * 0.3}px`,
        `${size * 0.2}px`,
        `${size * 0.3}px`,
        `${size * 0.2}px`,
      ],
    },
  };

  const imageSrc =
    router.query.openGaia === "true" && !isLoadingSessionNxtx
      ? "/nexa-icon.svg"
      : "/nexa-icon-neutral.svg";

  return (
    <div className="relative w-full h-full flex justify-center items-center">
      {isLoadingSessionNxtx ? (
        <motion.div
          variants={variants}
          animate="squeezeBoth"
          transition={{
            duration: 2,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "loop",
          }}
        >
          <Image alt="nexa_menu" src={imageSrc} width={size} height={size} />
        </motion.div>
      ) : (
        <Image alt="nexa_menu" src={imageSrc} width={size} height={size} />
      )}
    </div>
  );
};
